export default __webpack_public_path__ + "static/media/shareTwitter.2d69e220.svg";